import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { Col, Row } from 'react-bootstrap';
import { GetErrorMessageByFieldNameType } from '../../../../../hooks/useErrors';
import { MaxContestsAllowedType, PartnerType, VtProviderType } from '../../types';
import GeneralSettingsCard from './components/GeneralSettingsCard';
import VtDocumentCard from './components/VtDocumentCard';

export interface VtDocumentCardI {
  vtProvider: VtProviderType;
  setVtProvider: Dispatch<SetStateAction<VtProviderType>>;
  vtProviderOptions: VtProviderType[];
  vtPurchaseProvider: VtProviderType;
  setVtPurchaseProvider: Dispatch<SetStateAction<VtProviderType>>;
  hasCustomLogo: boolean;
  setHasCustomLogo: Dispatch<SetStateAction<boolean>>;
  showTicketsAtNotOptimizedResults: boolean;
  setShowTicketsAtNotOptimizedResults: Dispatch<SetStateAction<boolean>>;
  hasCustomTextAtLetter: boolean;
  handleHasCustomTextAtLetterChange: (hasCustomText: boolean) => void;
  customTextAtLetter: string;
  handleCustomTextAtLetterChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  getErrorMessageByFieldName: GetErrorMessageByFieldNameType;
  canRequestVtItemRelation: boolean;
  setCanRequestVtItemRelation: Dispatch<SetStateAction<boolean>>;
}

export interface GeneralSettingsCardI {
  partner: PartnerType;
  setPartner: Dispatch<SetStateAction<PartnerType>>;
  partnerOptions: PartnerType[];
  secondPartner: PartnerType;
  setSecondPartner: Dispatch<SetStateAction<PartnerType>>;
  secondPartnerOptions: PartnerType[];
  directResult: boolean;
  setDirectResult: Dispatch<SetStateAction<boolean>>;
  maxContestsAllowed: MaxContestsAllowedType;
  setMaxContestsAllowed: Dispatch<SetStateAction<MaxContestsAllowedType>>;
  defaultWorkplaceUsesIntegrationWs: boolean;
  setDefaultWorkplaceUsesIntegrationWs: Dispatch<SetStateAction<boolean>>;
  changesWpDataByWs: boolean;
  setChangesWpDataByWs: Dispatch<SetStateAction<boolean>>;
  isPartner: boolean;
  setIsPartner: Dispatch<SetStateAction<boolean>>;
  usesLogoAtEmail: boolean;
  setUsesLogoAtEmail: Dispatch<SetStateAction<boolean>>;
  canRequestVtItemRelation: boolean;
  setCanRequestVtItemRelation: Dispatch<SetStateAction<boolean>>;
  particularities: string;
  setParticularities: Dispatch<SetStateAction<string>>;
}

interface GeneralSettingsTabI extends VtDocumentCardI, GeneralSettingsCardI {}

export default function GeneralSettingsTab({
  vtProvider,
  setVtProvider,
  vtProviderOptions,
  vtPurchaseProvider,
  setVtPurchaseProvider,
  hasCustomLogo,
  setHasCustomLogo,
  showTicketsAtNotOptimizedResults,
  setShowTicketsAtNotOptimizedResults,
  hasCustomTextAtLetter,
  handleHasCustomTextAtLetterChange,
  customTextAtLetter,
  handleCustomTextAtLetterChange,
  partner,
  setPartner,
  partnerOptions,
  secondPartner,
  setSecondPartner,
  secondPartnerOptions,
  directResult,
  setDirectResult,
  maxContestsAllowed,
  setMaxContestsAllowed,
  getErrorMessageByFieldName,
  defaultWorkplaceUsesIntegrationWs,
  setDefaultWorkplaceUsesIntegrationWs,
  changesWpDataByWs,
  setChangesWpDataByWs,
  isPartner,
  setIsPartner,
  usesLogoAtEmail,
  setUsesLogoAtEmail,
  canRequestVtItemRelation,
  setCanRequestVtItemRelation,
  setParticularities,
  particularities,
}: GeneralSettingsTabI) {
  return (
    <Row xs={1} md={1} lg={1}>
      <Col>
        <VtDocumentCard
          vtProvider={vtProvider}
          setVtProvider={setVtProvider}
          vtProviderOptions={vtProviderOptions}
          vtPurchaseProvider={vtPurchaseProvider}
          setVtPurchaseProvider={setVtPurchaseProvider}
          hasCustomLogo={hasCustomLogo}
          setHasCustomLogo={setHasCustomLogo}
          showTicketsAtNotOptimizedResults={showTicketsAtNotOptimizedResults}
          setShowTicketsAtNotOptimizedResults={setShowTicketsAtNotOptimizedResults}
          hasCustomTextAtLetter={hasCustomTextAtLetter}
          handleHasCustomTextAtLetterChange={handleHasCustomTextAtLetterChange}
          customTextAtLetter={customTextAtLetter}
          handleCustomTextAtLetterChange={handleCustomTextAtLetterChange}
          getErrorMessageByFieldName={getErrorMessageByFieldName}
          canRequestVtItemRelation={canRequestVtItemRelation}
          setCanRequestVtItemRelation={setCanRequestVtItemRelation}
        />
      </Col>
      <Col>
        <GeneralSettingsCard
          partner={partner}
          setPartner={setPartner}
          partnerOptions={partnerOptions}
          secondPartner={secondPartner}
          setSecondPartner={setSecondPartner}
          secondPartnerOptions={secondPartnerOptions}
          directResult={directResult}
          setDirectResult={setDirectResult}
          maxContestsAllowed={maxContestsAllowed}
          setMaxContestsAllowed={setMaxContestsAllowed}
          defaultWorkplaceUsesIntegrationWs={defaultWorkplaceUsesIntegrationWs}
          setDefaultWorkplaceUsesIntegrationWs={setDefaultWorkplaceUsesIntegrationWs}
          changesWpDataByWs={changesWpDataByWs}
          setChangesWpDataByWs={setChangesWpDataByWs}
          isPartner={isPartner}
          setIsPartner={setIsPartner}
          usesLogoAtEmail={usesLogoAtEmail}
          setUsesLogoAtEmail={setUsesLogoAtEmail}
          canRequestVtItemRelation={canRequestVtItemRelation}
          setCanRequestVtItemRelation={setCanRequestVtItemRelation}
          setParticularities={setParticularities}
          particularities={particularities}
        />
      </Col>
    </Row>
  );
}
